import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const FeaturedText = ({ text }) => <S.Text>{text}</S.Text>;

export default FeaturedText;

FeaturedText.propTypes = {
  text: PropTypes.string.isRequired,
};
